import {NgModule} from "@angular/core";
import {CommonModule, NgOptimizedImage} from "@angular/common";
import {MatIconModule} from "@angular/material/icon";
import {MatInputModule} from '@angular/material/input';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatButtonModule} from "@angular/material/button";
import { NgxStarsModule } from "ngx-stars";
import {MenuRatingComponent} from "./menu-rating.component";
import {UploadImageModule} from "../upload-image/upload-image.module";


@NgModule({
  declarations: [MenuRatingComponent],
    imports: [
        CommonModule,
        MatIconModule,
        ReactiveFormsModule,
        FormsModule,
        MatFormFieldModule,
        MatButtonModule,
        MatInputModule,
        NgxStarsModule,
        NgOptimizedImage,
      UploadImageModule,
    ],
  exports: [
    MenuRatingComponent
  ]
})
export class MenuRatingModule {
}
